// @see https://developer.mozilla.org/ja/docs/Web/API/UserActivation
export const getHasUserActivation = (): boolean =>
  typeof navigator !== "undefined" &&
  "userActivation" in navigator &&
  !!navigator.userActivation?.hasBeenActive;
